module.exports = __webpack_public_path__ + "static/media/DBWhite.de8769d2.svg";